import { Search, Bell, LogOut, Menu } from 'lucide-react';
import { getUser, logout } from '@/lib/auth';

interface Props {
  onMenuClick: () => void;
}

export default function Topbar({ onMenuClick }: Props) {
  const user = getUser();

  return (
    <header className="sticky top-0 z-20 flex h-14 md:h-16 items-center gap-2 md:gap-3 border-b border-line bg-white/90 px-3 md:px-6 backdrop-blur">
      <button
        type="button"
        onClick={onMenuClick}
        className="grid h-10 w-10 shrink-0 place-items-center border border-line bg-white text-ink/70 transition hover:text-ink md:hidden"
        aria-label="Открыть меню"
      >
        <Menu size={18} strokeWidth={1.75} />
      </button>

      <div className="relative hidden sm:block flex-1 max-w-md">
        <Search
          size={16}
          strokeWidth={1.75}
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-ink/40"
        />
        <input
          type="search"
          placeholder="Поиск арендатора, email, ИНН…"
          className="block w-full border border-line bg-paper pl-9 pr-3 py-2 text-[13px] text-ink placeholder:text-ink/40 focus:border-ink focus:bg-white focus:outline-none transition"
        />
      </div>

      {/* Растяжка на мобильной версии, чтобы правый блок был справа */}
      <div className="flex-1 sm:hidden" />

      <button
        type="button"
        className="hidden sm:grid h-10 w-10 place-items-center border border-line bg-white text-ink/70 transition hover:text-ink"
        aria-label="Уведомления"
      >
        <Bell size={16} strokeWidth={1.75} />
      </button>

      <div className="flex items-center gap-2 md:gap-3 md:border-l md:border-line md:pl-4">
        <div className="hidden text-right lg:block">
          <div className="text-[13px] font-medium leading-tight text-ink">
            {user?.name ?? 'Platform Admin'}
          </div>
          <div className="text-[11px] text-ink/50">{user?.email ?? 'admin@resstro.ru'}</div>
        </div>
        <div className="grid h-9 w-9 shrink-0 place-items-center bg-ink text-[12px] font-medium uppercase text-white">
          {(user?.name ?? 'PA')
            .split(' ')
            .map((s) => s[0])
            .slice(0, 2)
            .join('')}
        </div>
        <button
          type="button"
          onClick={() => logout()}
          className="btn-ghost h-10 px-2 md:px-4"
          title="Выйти"
          aria-label="Выйти"
        >
          <LogOut size={16} strokeWidth={1.75} />
        </button>
      </div>
    </header>
  );
}
